export const LANGUAGE_SELECT_MODAL_ID = 'languageSelect';
